/**
 * Created by panko on 04.09.2017.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {Http, Response} from '@angular/http';
import 'rxjs/Rx';

@Injectable()
export class HttpService {
  // private url = 'https://medbeauty.pl.ua/';
  private url = 'https://work.medbeauty.pl.ua/';
  private options: object;
  constructor(private http: Http) {
    this.setHeaders();
  }

  setHeaders() {
    // let headers = new Headers(
    //   {
    //     'Access-Control-Allow-Origin': 'https://work.medbeauty.pl.ua/'
    //   }
    // );
    // this.options = new RequestOptions({ headers: headers });
  }

  get(url): Observable<Comment[]> {
    this.setHeaders();
    return this.http.get(this.url + url, this.options)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res.json();
      })
      // ...errors if any
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  post(url, data): Observable<Comment[]> {
    this.setHeaders();
    let json = JSON.stringify(data);
    return this.http.post(this.url + url, json, this.options)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res.json();
      })
      // ...errors if any
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  put(url, data): Observable<Comment[]> {
    this.setHeaders();
    let json = JSON.stringify(data);
    return this.http.put(this.url + url, json, this.options)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res.json();
      })
      // ...errors if any
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  delete(url): Observable<Comment[]> {
    this.setHeaders();
    return this.http.delete(this.url + url, this.options)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res.json();
      })
      // ...errors if any
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/http.service.ts